module.exports = __webpack_public_path__ + "img/pending_zone_selected.28869663.svg";